/**
 * Helper function that returns an index that is safe to use as an index for a
 * collection.
 * @param index
 * @param length length of the collection
 */
export function getSafeIndex(index: number, length: number) {
  return (index < 0 ? 0 : index) % length;
}
